export default [
  {
    path: '/main/arena/equipments',
    meta: {
      tag: 'list_arena_equipments',
      name: 'Equipamentos (Arena)',
      breadcrumb: 'Equipamentos (Arena)'
    },
    component: () => import(/* webpackChunkName: "arena-equipments-list" */ '@/views/main/settings/arena/equipment/Index.vue'),
    children: [
      {
        path: '',
        name: 'listarenaequipment',
        meta: {
          tag: 'list_arena_equipments',
          menu: 'settings',
          name: 'Equipamentos (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-equipments-list" */ '@/views/main/settings/arena/equipment/List.vue'),
      },
      {
        path: '/main/arena/equipment/add',
        name: 'addarenaequipment',
        meta: {
          tag: 'add_arena_equipment',
          menu: 'settings',
          name: 'Adicionar | Equipamento (Arena)',
          breadcrumb: 'Adicionar Equipamento (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-equipment-add" */ '@/views/main/settings/arena/equipment/Add.vue')
      },
      {
        path: '/main/arena/equipment/:id',
        name: 'editarenaequipment',
        meta: {
          tag: 'edit_arena_equipment',
          menu: 'settings',
          name: 'Editar | Equipamento (Arena)',
          breadcrumb: 'Editar Equipamento (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-equipment-edit" */ '@/views/main/settings/arena/equipment/Edit.vue')
      }
    ]
  }
]
